import { postData } from '../../Survey/helpers/fetch_services';

/** Loads survey definition for the L&D knowledge check. */
export async function fetchLearningSurvey(surveyId) {
  const result = await postData('frontEmployeeFeedback/getSurvey', {
    survey_id: surveyId,
  });

  if (!result?.success) {
    throw new Error(result?.message || 'Unable to load questionnaire.');
  }

  return result.data;
}
